export const PAYMENT_METHODS = {
  cashOrCard: 'cash_or_card',
  cashOnly: 'cash_only',
  cardOnline: 'card_online',
  online: 'online',
  fps: 'FPS',
  installmentSovcombank: 'installment_sovcombank',
  sberbank: 'SBERBANK',
  sovсombank: 'SOVCOMBANK',
};

export const CARD_ONLINE = {
  title: 'Онлайн-оплата',
  altTitle: 'Онлайн-оплата картой на сайте',
  subtitle: 'Удобный и безопасный способ оплаты заказа',
  value: PAYMENT_METHODS.cardOnline,
  icon: ['IconCard'],
  altIcon: ['IconCard', 'IconMir', 'IconMastercard', 'IconVisa', 'IconHalva'],
};

export const FPS = {
  title: 'Система Быстрых Платежей',
  subtitle: 'Моментальный возврат средств при возврате товара',
  value: PAYMENT_METHODS.fps,
  icon: 'IconFPS',
};

export const CASH_OR_CARD = {
  title: 'Наличными или картой',
  subtitle: 'При получении в магазине или курьером',
  value: PAYMENT_METHODS.cashOrCard,
  icon: 'IconWallet',
  altIcon: '',
};

export const CASH_ONLY = {
  title: 'Наличными',
  subtitle: 'При получении в магазине или курьером',
  value: PAYMENT_METHODS.cashOnly,
  icon: 'IconCash',
  altIcon: '',
};

export const INSTALLMENT_SOVCOMBANK = { // рассрочка
  title: 'Оплата частями',
  value: PAYMENT_METHODS.installmentSovcombank,
  icon: 'IconInstallment',
  altIcon: '',
  acquiring: 'SOVCOMBANK',
  hasInfoElement: true,
};

// TODO: брать сортировку для вывода методов оплаты из API
export const ACTIVE_PAYMENT_METHODS = [
  FPS,
  CARD_ONLINE,
  CASH_OR_CARD,
  CASH_ONLY,
  INSTALLMENT_SOVCOMBANK,
];

export const DEFAULT_METHOD = PAYMENT_METHODS.fps;

export const PAYMENT_STATUSES = {
  paid: 'paid',
  overpay: 'overpay',
  underpay: 'underpay',
  notPaid: 'not_paid',
  processing: 'processing',
  failed: 'failed',
};
